<h2 mat-dialog-title>Processing...</h2>
<mat-dialog-content class="mat-typography">
  <div class="loading-container">
    <mat-spinner diameter="50"></mat-spinner>
    <p>{{ message }}</p>
  </div>
</mat-dialog-content>